import { cardsData } from './cardsData';

export const getCardsByLanguage = (language = 'en') => {
  const data = cardsData[language];
  
  // 确保返回的是数组
  if (!Array.isArray(data)) {
    console.error(`cardsData[${language}] is not an array:`, data);
    return cardsData.en || [];
  }
  
  return data;
};

export default getCardsByLanguage;
